import { render, staticRenderFns } from "./AdministracionDeClientes.vue?vue&type=template&id=66a671b8&scoped=true&"
import script from "./AdministracionDeClientes.vue?vue&type=script&lang=js&"
export * from "./AdministracionDeClientes.vue?vue&type=script&lang=js&"
import style0 from "./AdministracionDeClientes.vue?vue&type=style&index=0&id=66a671b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a671b8",
  null
  
)

export default component.exports